import { gaEvent } from "analytics/analytics";
import {
  message,
  Modal,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Button,
  Alert,
} from "antd";
import { useEffect, useState } from "react";
import { Colors } from "theme";
import * as GA from "constants/analytics";
import { BsGearFill } from "react-icons/bs";
import DrawerModal from "routes/SourceWiz/CreateCollection/DrawerModal";
import LinkSettings from "routes/SourceWiz/CreateCollection/LinkSettings";
import {
  updateLinkSecurityData,
  getLinkSecurityData,
  createLinkSecurityData,
} from "api/customApis";
import utils from "routes/SourceWiz/CreateCollection/LinkSettings/utils";
import moment from "moment-timezone";
import Can from "../../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
const { Title, Text } = Typography;

export default function ContinueModal({
  showContinue,
  handleContinue,
  handlePreview,
  handleCloseModal,
  collectionDetails,
  data,
  allProducts,
  setCollectionStatus,
  flags,
  genarateCatalogoueModalVisible,
  handleCancelGenarateCatalogoueModal,
  handleOkGenarateCatalogoueModal,
  saveAsDraft,
  uniqueAttrs,
}) {
  const [form] = Form.useForm();
  const [drawerStatus, setDrawerStatus] = useState(false);
  const [pptData, setpptData] = useState({});
  const [pptTitle, setpptTitle] = useState(
    "Each slide will have upto 2 images of a single product along with ID and other details"
  );
  const [linkSettingsVisible, setLinkSettingsStatus] = useState(false);
  const [linkSettingsData, setLinkSettingsData] = useState();
  const [greyBoxData, setGreyBoxData] = useState([]);
  const [linkSettingsId, setLinkSettingsId] = useState();

  const handlePptData = (data) => {
    setpptData(data);
    if (data.products_per_slide === 1) {
      setpptTitle(
        "Each slide will have upto 2 images of a single product along with ID and other details"
      );
    } else {
      setpptTitle(
        `Each slide will have ${data.products_per_slide} products along with Product ID`
      );
    }
  };

  useEffect(() => {
    if (collectionDetails) {
      getLinkSecurityData(collectionDetails?.collection_link)
        .then((res) => {
          setLinkSettingsData(res.data.security_data);
          setLinkSettingsId(res.data.id);
          const g = utils.getGreyBoxData(res.data.security_data);
          setGreyBoxData(g);
        })
        .catch((e) => {});
    }
  }, [collectionDetails]);

  useEffect(() => {
    if (collectionDetails) {
      form.setFieldsValue({
        buyer_name: collectionDetails?.buyer_name,
        collection_name: collectionDetails?.collection_name,
        email_ids: collectionDetails?.email_ids?.[0],
      });
    }
  }, [form, collectionDetails]);

  const submitLinkSettingsData = (
    linkSettingsDataParams,
    generateCatalogueParams
  ) => {
    updateLinkSecurityData(linkSettingsId, linkSettingsDataParams)
      .then(() => {
        handleContinue({
          ...generateCatalogueParams,
          ppt_export: pptData,
        });
      })
      .catch(() => message.error("Failed to generate catalgoue. Try again"));
  };

  const onFinish = (values) => {
    if (linkSettingsData && linkSettingsData.expiry) {
      const endDate = moment(linkSettingsData.expiry.to);
      const todayDate = moment(moment().format("YYYY-MM-DD"));
      if (!endDate.isSameOrAfter(todayDate)) {
        const finalData = {
          email: linkSettingsData.email,
        };
        if (linkSettingsData.passcode) {
          finalData.passcode = linkSettingsData.passcode;
        }

        submitLinkSettingsData(finalData, values);
      } else {
        handleContinue({
          ...values,
          ppt_export: pptData,
        });
      }
    } else {
      handleContinue({
        ...values,
        ppt_export: pptData,
      });
    }
  };

  const onFinishFailed = (errorInfo) => {};

  const handleUpdateLinkSettingsData = (id, greyBoxData, finalData) => {
    setLinkSettingsData(finalData);
    setGreyBoxData(greyBoxData);
    setLinkSettingsId(id);
  };

  return (
    <Modal
      visible={genarateCatalogoueModalVisible}
      onOk={() => onFinish()}
      onCancel={() => handleCancelGenarateCatalogoueModal()}
      destroyOnClose={true}
      footer={null}
      width={"50%"}
      bodyStyle={{ padding: "2.5rem" }}
      centered
    >
      <Form
        name="collection-details"
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          <Col span={24}>
            <Title level={2} style={{ fontFamily: "Gilroy", margin: 0 }}>
              Confirm all details
            </Title>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {data &&
              data.map((item, index) => (
                <Text
                  key={index}
                  style={{ marginRight: 5 }}
                  type="secondary"
                >{`${item?.name} (${
                  item?.values.length ? item?.values.length : 0
                })`}</Text>
              ))}
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Row style={{ marginTop: "2rem" }}>
              <Col span={24}>
                <Form.Item
                  style={{ marginBottom: 40 }}
                  label="Catalogue name"
                  name="collection_name"
                  rules={[{ required: true, message: "Enter catalogue name" }]}
                >
                  <Input
                    size="large"
                    onClick={() => {
                      gaEvent(
                        GA.EVENT.CLICK,
                        GA.CATEGORY.CREATE_COLLECTION,
                        GA.DESCRIPTION.GENERATE_CATALOGUE_INPUT_CATALOGUE_NAME
                      );
                    }}
                  />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: 40 }}
                  label="Buyer Company name"
                  name="buyer_name"
                  rules={[{ required: true, message: "Enter company name" }]}
                >
                  <Input
                    size="large"
                    onClick={() => {
                      gaEvent(
                        GA.EVENT.CLICK,
                        GA.CATEGORY.CREATE_COLLECTION,
                        GA.DESCRIPTION.GENERATE_CATALOGUE_INPUT_COMPANY_NAME
                      );
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label="Buyer Email ID"
                  name="email_ids"
                  style={{ marginBottom: 40 }}
                  rules={[
                    {
                      required: false,
                      type: "email",
                      message: "Enter valid email",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    onClick={() => {
                      gaEvent(
                        GA.EVENT.CLICK,
                        GA.CATEGORY.CREATE_COLLECTION,
                        GA.DESCRIPTION.GENERATE_CATALOGUE_INPUT_EMAIL
                      );
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row
          style={{ backgroundColor: "#F1F7FF", padding: 20, borderRadius: 4 }}
        >
          <Col span={20}>
            <Row>
              <Title level={5}>Presentation template</Title>
            </Row>
            <Row>
              <div style={{ fontSize: 14, color: "#686E6D" }}>{pptTitle}</div>
            </Row>
          </Col>
          <Col span={4} style={{ display: "flex", justifyContent: "flex-end" }}>
            <div style={{ marginTop: 2, marginRight: 4 }}>
              <BsGearFill color="#0B7764" />
            </div>
            <div
              style={{ cursor: "pointer", color: "#0B7764" }}
              onClick={() => setDrawerStatus(true)}
            >
              Update
            </div>
          </Col>
        </Row>
        <DrawerModal
          uniqueAttrs={uniqueAttrs}
          handlePptData={handlePptData}
          visible={drawerStatus}
          setDrawerStatus={setDrawerStatus}
        />

        <Row
          style={{
            marginTop: "1rem",
            backgroundColor: "#F5F5F5",
            padding: 20,
            borderRadius: 4,
          }}
        >
          <Col span={20}>
            <Row>
              <Title level={5}>Link Settings</Title>
            </Row>
            {greyBoxData?.map((item) => {
              return (
                <div
                  style={{
                    flexDirection: "row",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "flexStart",
                  }}
                >
                  <div style={{ marginRight: "0.5rem" }}>{item.render()}</div>

                  <div style={{ fontSize: 14, color: "#686E6D" }}>
                    {item.message}
                  </div>
                </div>
              );
            })}
          </Col>
          <Col span={4} style={{ display: "flex", justifyContent: "flex-end" }}>
            <div style={{ marginTop: 2, marginRight: 4 }}>
              <BsGearFill color="#0B7764" />
            </div>
            <div
              style={{ cursor: "pointer", color: "#0B7764" }}
              onClick={() => setLinkSettingsStatus(true)}
            >
              Update
            </div>
          </Col>
        </Row>
        {collectionDetails && (
          <LinkSettings
            visible={linkSettingsVisible}
            setDrawerStatus={setLinkSettingsStatus}
            collectionLink={collectionDetails?.collection_link}
            collectionId={collectionDetails?.id}
            linkSettingsData={linkSettingsData}
            linkSettingsId={linkSettingsId}
            handleUpdateLinkSettingsData={handleUpdateLinkSettingsData}
          />
        )}

        <Row justify="space-between" style={{ marginTop: "2rem" }}>
          <Col>
            {" "}
            <Button
              size="large"
              style={{
                width: "100%",
                backgroundColor: "#F0F8F6",
                color: "#0B7764",
                border: "1px solid #54A093",
              }}
              onClick={() => {
                handlePreview(
                  {
                    ppt_export: pptData,
                    status: "draft",
                  },
                  () => {
                    window.open(
                      `${process.env.REACT_APP_URL}${collectionDetails?.collection_link}?type=PREVIEW`
                    );
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.CREATE_COLLECTION,
                      GA.DESCRIPTION.GENERATE_CATALOGUE_PREVIEW_BUTTON
                    );
                  }
                );
              }}
            >
              Preview Catalogue
            </Button>
          </Col>

          <Can  I={PERMISSIONS.create_catalogues.slug}
          a={PERMISSIONS.create_catalogues.permissionType} >
          <Col>
            {" "}
            <Button
              size="large"
              style={{ width: "100%", backgroundColor: "#1D2624", border: 0 }}
              htmlType="submit"
              type="primary"
              onClick={() => {
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.CREATE_COLLECTION,
                  GA.DESCRIPTION.GENERATE_CATALOGUE_GENERATE_BUTTON
                );
              }}
            >
              Generate catalogue
            </Button>{" "}
          </Col>
          </Can>
        </Row>
      </Form>
    </Modal>
  );
}
